import {
  Droplet,
  Heart,
  Scale,
  Smartphone,
  Wind,
} from "lucide-react";
import type { ComponentType } from "react";

export type PatientReadingTab = {
  name: string;
  value: string;
  deviceType: string | null;
  isDeviceTab: boolean;
  icon: ComponentType<{ className?: string }>;
  isPulseRateTab?: boolean;
};

export const DEVICE_TAB_CONFIG: PatientReadingTab[] = [
  { name: "List", value: "device", deviceType: null, isDeviceTab: true, icon: Smartphone },
  {
    name: "Blood Pressure",
    value: "blood_pressure",
    deviceType: "blood_pressure",
    isDeviceTab: false,
    icon: Heart,
  },
  {
    name: "Blood Glucose",
    value: "blood_glucose",
    deviceType: "glucose_meter",
    isDeviceTab: false,
    icon: Droplet,
  },
  {
    name: "Blood Oxygen",
    value: "pulse_oximeter",
    deviceType: "pulse_oximeter",
    isDeviceTab: false,
    icon: Wind,
  },
  {
    name: "Weight Scale",
    value: "weight_scale",
    deviceType: "weight_scale",
    isDeviceTab: false,
    icon: Scale,
  },
];
